// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jyB5","questions":"styles_questions__3Iok3","footer":"styles_footer__1KH_U"};